export default __webpack_public_path__ + "static/media/profile.fc73cc29.png";